import { render, staticRenderFns } from "./MatchMakingRules.vue?vue&type=template&id=64bf6099&"
import script from "./MatchMakingRules.vue?vue&type=script&lang=ts&"
export * from "./MatchMakingRules.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports